export const MUTATION_BATCH_COUNT = 50;
export const MUTATION_BATCH_BYTES = 512 * 1024; // 512 KiB

export function estimateJsonBytes(value: unknown): number {
  try {
    return new TextEncoder().encode(JSON.stringify(value)).length;
  } catch {
    return 1024;
  }
}

export function selectMutationBatch<T>(
  items: T[],
  maxCount = MUTATION_BATCH_COUNT,
  maxBytes = MUTATION_BATCH_BYTES
): T[] {
  const selected: T[] = [];
  let totalBytes = 0;

  for (const item of items) {
    if (selected.length >= maxCount) break;
    const itemBytes = estimateJsonBytes(item);
    if (selected.length > 0 && totalBytes + itemBytes > maxBytes) {
      break;
    }
    selected.push(item);
    totalBytes += itemBytes;
  }
  return selected;
}
